"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useOnClickOutside(refs, handler, flag = true) {
    (0, react_1.useEffect)(() => {
        const listener = (event) => {
            if (refs &&
                refs.some((item) => !item.current || item.current.contains(event.target))) {
                return;
            }
            handler(event);
        };
        if (flag) {
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchend', listener);
        }
        else {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchend', listener);
        }
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchend', listener);
        };
    }, [refs, handler, flag]);
}
exports.default = useOnClickOutside;
